<template>
    <BaseModal :id="'static-permissions'" :title="title" :size="'lg'" :message="message" :disable_close="true">

        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb" />
        </template>

        <template v-slot:content>
            <template v-if="show_go_back">
                <button type="button" class="modal__buttons__item ml-0 mt-3" data-dismiss="modal" aria-label="Close" v-html="'Go back'" @click="$emit('modal_update', index)" />
            </template>
            <form class="row ml-0 mr-0 mb-0 mt-3" @submit.prevent="updatePermissions()" v-if="!is_loading">
                <label class="modal-label active"> {{countTotalPermissionsGiven}} out of {{ countTotalPermissions }} permissions given</label>
                <div class="overflow-auto ml-0 mr-0 mb-0 mt-2 shadow-sm p-3" style="max-height:35rem">
                    <div v-for="(item, i) in permissions" :key="i" class="row mb-0">
                        <b class="ml-1">{{ countPermissionsByModule(i)[0] + ' out of ' + countPermissionsByModule(i)[1] + ' permissions given' }}</b>
                        <div class="custom-control custom-checkbox d-block col-md-12 ml-2">
                            <span>
                                <input :id="`theadcheck${item.module}`" type="checkbox" class="custom-control-input ml-2" @change="selectAll(item, $event)" :ref="`theadcheck${item.module}`" :disabled="!hasPermissions(['Associate Permissions-Write'])"/>
                                <label :for="`theadcheck${item.module}`" class="custom-control-label ml-2" v-html="'Check all'" />
                            </span>
                            <span class="ml-3">
                                <input :id="`theadcheckWrite${item.module}`" type="checkbox" class="custom-control-input" @change="selectAll(item, $event, 'write')" :ref="`theadcheckWrite${item.module}`" :disabled="!hasPermissions(['Associate Permissions-Write'])"/>
                                <label :for="`theadcheckWrite${item.module}`" class="custom-control-label ml-4" v-html="'Check all Write'" />
                            </span>
                            <span class="ml-3">
                                <input :id="`theadcheckRead${item.module}`" type="checkbox" class="custom-control-input" @change="selectAll(item, $event, 'read')" :ref="`theadcheckRead${item.module}`" :disabled="!hasPermissions(['Associate Permissions-Write'])"/>
                                <label :for="`theadcheckRead${item.module}`" class="custom-control-label ml-4" v-html="'Check all Read'" />
                            </span>
                            <span class="ml-3">
                                <input :id="`theadcheckUpload${item.module}`" type="checkbox" class="custom-control-input" @change="selectAll(item, $event, 'upload')" :ref="`theadcheckUpload${item.module}`" :disabled="!hasPermissions(['Associate Permissions-Write'])"/>
                                <label :for="`theadcheckUpload${item.module}`" class="custom-control-label ml-4" v-html="'Check all Uploads'" />
                            </span>
                        </div>
                        <div class="row associate-permissions ml-0 mr-0">
                            <div class="col-md-2 col-sm-2 associate-permissions__module">
                                <span class="d-flex align-items-center justify-content-center">
                                    {{ item.module }}
                                </span>
                            </div>
                            <div class="col-md-10 col-sm-10 p-0">
                                <div class="row mb-0 ml-0 mr-0 mt-0" :class="item.module">
                                    <div class="col-md-4 col-sm-12 associate-permissions__group" v-for="group_permision in item.group_permissions" :key="group_permision.id">
                                        <div class="formdynamic__item__field associate-permissions__permission">
                                            <label v-html="`${group_permision.name}`" class="modal-label mb-2" />
                                            <div class="px-0 col-md-12 p-0" v-for="(value, i) in group_permision.permissions" :key="i">
                                                <div class="custom-control custom-checkbox">
                                                    <input :id="`${value.name}`" type="checkbox" class="custom-control-input" :value="value.name" v-model="associate_permissions" :disabled="!hasPermissions(['Associate Permissions-Write'])"/>
                                                    <label :for="`${value.name}`" class="custom-control-label ml-2" v-html="value.alias" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal__buttons text-right col-12 p-0">
                    <button type="button" class="modal__buttons__item cancel" data-dismiss="modal" aria-label="Close" v-html="'Cancel'" @click="cancel()" />
                    <button class="modal__buttons__item" v-html="`Save <img class='ml-2' width='15px' src='/assets/img/svg/add-w.svg' alt=''/>`" />
                </div>
            </form>
        </template>
    </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseModal'
import FormResources from './form_resources'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import { Notyf } from 'notyf'
import 'notyf/notyf.min.css'
const notyf = new Notyf({ duration: 8000 })

export default {

    name: 'FormModalPermissionsComponent',
    props: [
        'show_go_back',
        'rest_api',
        'array_options',
        'breadcrumb',
        'permissions',
    ],

    components: {
        BaseModal,
        Breadcrumb,
    },

    data() {
        return {
            form_format: FormResources.form_format,
            form_backup: { ...FormResources.form_data },
            form_data: FormResources.form_data,
            message: `Here, you can easily allocate specific permissions to your associates based on their roles and responsibilities within different modules of our system. The permissions are conveniently grouped by their parent modules to streamline the assignment process.`,
            index: undefined,
            for_update: false,
            title: 'Associate Permissions',
            notyf,
            associate_permissions: [],
            per: [],
            associate: {},
            is_loading: true,
        }
    },

    methods: {
        async modalForUpdate(obj, index) {
            this.is_loading = true

            this.associate = obj
            this.associate_permissions = []

            const response = await this.get(`${this.rest_api}/permissions/${obj.id}`)
            if (response.status) {
                const permissions = response.data.permissions
                this.associate_permissions = permissions
            }

            this.is_loading = false

            this.title = obj.associate_name + ' - Permissions'
            this.index = index;

            this.permissions.forEach(item => {
                window.$(`#theadcheckFormWrite${item.module}`).prop('checked', false);
                window.$(`#theadcheckFormRead${item.module}`).prop('checked', false);
                window.$(`#theadcheckFormUpload${item.module}`).prop('checked', false);
            })
        },

        async updatePermissions() {
            window.$('#static-permissions').modal('hide')
            this.loader(true)
            const res = await this.put(`${this.rest_api}/sync_roles/${this.associate.id}`, { permissions: this.associate_permissions })

            if (res.status) 
            {
                notyf.success(`Updated success!`)
            } 
            else 
            {
                this.error_handling(res)
                setTimeout(() => {
                    window.$('#static-permissions').modal('show')
                }, 300);
            }

            this.loader()
        },

        selectAll(item, event, type = null)
        {
            let is_checked = event.target.checked

            item.group_permissions.forEach(group_permission => 
            {
                let filter_permissions

                if(!type)
                {
                    filter_permissions = group_permission.permissions
                    window.$(`#theadcheckWrite${item.module}`).prop('checked', is_checked);
                    window.$(`#theadcheckRead${item.module}`).prop('checked', is_checked);
                    window.$(`#theadcheckUpload${item.module}`).prop('checked', is_checked);
                }
                else
                {
                    filter_permissions = group_permission.permissions.filter(item => item.name.toLowerCase().includes(type))
                }

                filter_permissions.forEach(permission => {

                    let index = this.associate_permissions.findIndex(item => item == permission.name)
                    if(is_checked)
                    {
                        if(index == -1)
                        {
                            this.associate_permissions.push(permission.name)
                        }
                    }
                    else
                    {
                        if(index > -1)
                        {
                            this.associate_permissions.splice(index, 1)
                        }
                    }

                })
            })
        },
        countPermissionsByModule(index) 
        {
            let count = 0
            let count_given_permissions = 0;

            this.permissions[index].group_permissions.forEach(group_permission => 
            {
                count += group_permission.permissions.length

                group_permission.permissions.forEach(permission => {
                    let found_index = this.associate_permissions.findIndex(associate_permission => associate_permission == permission.name)
                    if(found_index > -1)
                    {
                        count_given_permissions += 1
                    }
                })
            })

            return [count_given_permissions, count]
        }
    },

    computed: 
    {
        countTotalPermissions()
        {
            let count = 0
            this.permissions.forEach(permission => {
                permission.group_permissions.forEach(group_permission => {
                    count += group_permission.permissions.length
                })
            })
            return count
        },

        countTotalPermissionsGiven()
        {
            let count = 0
            this.permissions.forEach(permission => {
                permission.group_permissions.forEach(group_permission => {
                    group_permission.permissions.forEach(ind_permission => 
                    {
                        let found_index = this.associate_permissions.findIndex(associate_permission => associate_permission == ind_permission.name)
                        if(found_index > -1)
                        {
                            console.log(ind_permission.group_permission_id);
                            count += 1
                        }
                    })
                })
            })
            return count
        }
    }

}
</script>
